import { useEffect, useMemo } from 'react'
import cn from 'classnames'
import { Form, Formik } from 'formik'
import { NavLink, useParams } from 'react-router-dom'
import * as Yup from 'yup'
import { useDispatch, useSelector } from 'react-redux'

import style from '@src/pages/Tariff/Tariff.module.scss'
import { IndividualsPanel } from '@src/components/IndividualsPanel/IndividualsPanel'
import { Footer } from '@src/components/Footer/Footer'
import { Button } from '@src/components/Button/Button'
import { FieldFormik } from '@src/components/common/FieldFormik/FieldFormik'
import { ReturnBtn } from '@src/components/Button/ReturnBtn'
import { phoneRegexp } from '@src/lib/regex'
import { validateForm } from '@src/messages/validateForm'
import { Modal } from '@src/components/common/Modal/Modal'
import { selectTariffError, selectTariffInformations } from '@src/store/ducks/tariffs/selectors'
import { AppDispatch } from '@src/store/store'
import { getTariffInfo } from '@src/store/ducks/tariffs/thunks'
import { tariffRequest } from '@src/store/ducks/contacts/thunks'
import {
  selectContactsIsLoadingTariffRequest,
  selectContactsIsSuccessTariffRequest,
} from '@src/store/ducks/contacts/selectors'
import { setIsSuccessTariffRequest } from '@src/store/ducks/contacts/reducer'
import { setPageTitle } from '@src/store/ducks/app/reducer'

export const Tariff = () => {
  const dispatch = useDispatch<AppDispatch>()
  const params = useParams<{ id: string }>()
  const tariffInformation = useSelector(selectTariffInformations)
  const tariffError = useSelector(selectTariffError)
  const isLoadingTariffRequest = useSelector(selectContactsIsLoadingTariffRequest)
  const isSuccessTariffRequest = useSelector(selectContactsIsSuccessTariffRequest)

  useEffect(() => { dispatch(setPageTitle(tariffInformation.title)) }, [dispatch, tariffInformation.title])

  useEffect(() => {
    dispatch(getTariffInfo(+params.id))
  }, [dispatch, params.id])

  const initialValues = useMemo(() => ({
    phone: '',
  }), [])

  const validationSchema = useMemo(() => (
    Yup.object().shape({
      phone: Yup.string().matches(phoneRegexp, validateForm.phone)
        .required(validateForm.required),
    })
  ), [])

  return (
    <>
      <IndividualsPanel />
      <div className={cn(style.tariffContainer, 'container')}>
        <ReturnBtn type="secondary">Вернуться</ReturnBtn>
        {tariffError ? (<h2 className={style.mainTitle}>Тариф не найден</h2>)
          : (
            <>
              <h2 className={style.mainTitle}>{tariffInformation.title}</h2>
              <div className={style.detailsBlock}>
                <div className={style.title}>Ежемесячная плата</div>
                <div className={cn(style.cost)}>
                  {tariffInformation.price && tariffInformation.price}
                  {' '}
                  <span>р.</span>
                </div>
              </div>
              {tariffInformation.lkDescription && (
                <>
                  <div className={style.secondTitle}>О тарифном плане</div>
                  <div className={style.descriptionTariff}>
                    <div dangerouslySetInnerHTML={{ __html: tariffInformation.lkDescription }} />
                  </div>
                </>
              )}
            </>
          )}
      </div>
      <div className={style.plugTariff}>
        <div className={cn(style.tariffContainer, 'container')}>
          <div className={style.formHint}>
            <span>
              <span className={style.divSpan}>Подключить </span>
              данный тарифный план
            </span>
          </div>
          <Formik
            validationSchema={validationSchema}
            initialValues={initialValues}
            onSubmit={({ phone }) => {
              dispatch(tariffRequest(phone, tariffInformation.title))
            }}
            enableReinitialize
          >
            <Form>
              <div className={style.box_1}>
                <FieldFormik
                  className={style.inputSize}
                  name="phone"
                  label="Введите ваш номер телефона"
                  placeholder="+375 (XX) XXX XX XX"
                  mask="+{375} (00) 000-00-00"
                />
              </div>
              <div className={`${style.btn}`}>
                <Button
                  className={style.btnSize}
                  type="primary"
                  loading={isLoadingTariffRequest}
                  htmlType="submit"
                >
                  Подключить
                </Button>
              </div>
            </Form>
          </Formik>
        </div>
      </div>
      <Footer className={style.borderNone} />
      <Modal isOpen={isSuccessTariffRequest} close={() => { dispatch(setIsSuccessTariffRequest(false)) }}>
        <>
          <div className={style.confirmActions}>
            Ваша заявка была
            <span className="blue"> успешно</span>
            {' '}
            оформлена!
          </div>
          <div className={style.btn}>
            <NavLink
              to="/"
            >
              <Button
                className={style.btnSize}
                type="primary"
              >
                В личный кабинет
              </Button>
            </NavLink>
          </div>
        </>
      </Modal>
    </>
  )
}
